
export default {
  name: 'PageInfo',
  components: {
  },
  props: {
    infoText: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: null
    },
    infoIcon: {
      type: String,
      default: 'check'
    },
  },
  methods: {
    reContents (text) {
      return text.split('\n')
    },
  }
}
